import { render } from "./sandText.vue?vue&type=template&id=0ecee760&scoped=true"
import script from "./sandText.vue?vue&type=script&lang=js"
export * from "./sandText.vue?vue&type=script&lang=js"

import "./sandText.vue?vue&type=style&index=0&id=0ecee760&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ecee760"]])

export default __exports__